import { render, staticRenderFns } from "./AddOnvifCamera.vue?vue&type=template&id=70ad6829&scoped=true&"
import script from "./AddOnvifCamera.vue?vue&type=script&lang=js&"
export * from "./AddOnvifCamera.vue?vue&type=script&lang=js&"
import style0 from "./AddOnvifCamera.vue?vue&type=style&index=0&id=70ad6829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad6829",
  null
  
)

export default component.exports